/**
 * @file 请求 - 上报
 * @author hardylin <hardylin@tencent.com>
 */
import axios from 'axios'
import { stringify } from '@tencent/slug-function'
import store from './../store'
import { mGetUrlParam } from './../utils/index'

/**
 * 性能数据上报
 * @param {Object} data - ajax 请求 `data` 参数
 * @param {Object} [data.speedparams] - 页面测速相关上报数据
 */
export function reportPerformanceData(data) {

    // 非正式环境不上报
    if (location.host != 'sy.qq.com') {
        return
    }

    axios({
        url: 'https://report.huatuo.qq.com/report.cgi',
        params: Object.assign({
            appid: '20571',
            platform: sessionStorage.igPlatform
        }, data)
    }).catch(error => {
        // 防止 Sentry 自动上报错误
    })
}



/**
 * DMP 埋点接口封装
 * @param {Object} data - 埋点所需的信息
 */
// export function reportToDMP({
//     action, // 用户行为：visit（进入微社区上报），pop（曝光），click（点击），pv（内容详情页访问上报），timeline（内容详情页离开上报），leave（离开微社区上报）
//     // adtag, // 来源入口信息
//     channelid = '', // 频道 ID，记录频道名称，如：王者世界
//     from = 'ingame', // 来源：tgl，v4，ingame
//     path = '', // 访问路径，离开微社区时上报用户完整路径，如：#/heroBook/139,#/heroBook/12
//     recid = '', // 推荐 id，如使用了推荐算法，记录推荐规则 id，如：rc02
//     // sourceid = '', // 上报的来源 id，四级路由 + 自定义标识，如：index.0.0.0.list
//     staytime = '', // 停留时长，内容详情页离开上报页面停留时长，离开微社区上报微社区访问时长，单位：秒
//     tag = '', // 目标标签
//     targettype = '', // 目标类型：news（资讯），video（视频），picture（图片），person（用户）
//     title = '', // 目标标题
//     targetid = '', // 操作的目标 id
//     top = false, // 是否置顶，true / false
//     hash = ''   // 路由地址，只在timeline用到
// } = data) {
//     //sourceid 处理
//     let arrHash = (hash||location.hash).replace(/^#?\//,'').replace(/\?(.)*/,'').split('/')
//     for (let i = 0; i < 5; i++) {
//         if (arrHash.length < i) {
//             arrHash.push('0')
//         }
//         if (i == 4){
//             arrHash[i] = 'page'
//         } else if (i == 0 && !arrHash[i]) {
//             arrHash[i] = 'index'
//         }
//     }
//     let sourceid = arrHash.join('.')
//     // 批量 & 单个判断
//     if (String(targetid).indexOf(',') !== -1) {
//         // 批量
//         title = title.replace(/\|/g, '-')
//     } else {
//         // 单个
//         title = title.replace(/\|/g, '-').replace(/\,/g, '，')
//     }

//     // pageid处理
//     let pageid = location.origin + location.pathname + location.hash // 页面标识

//     // // 无登录态则不上报
//     // if (!sessionStorage.tokenParams) {
//     //     return
//     // }

//     return axios({
//         method: 'POST',
//         url: '//app.ingame.qq.com/gingame/report/tdbank',
//         headers: {
//             'Content-Type': 'application/x-www-form-urlencoded'
//         },
//         data: stringify({
//             business: 'dmp',
//             data: `${ store.state.global.game }|${ mGetUrlParam('acctype', sessionStorage.tokenParams) }|${ mGetUrlParam('platid', sessionStorage.tokenParams) }|${ mGetUrlParam('openid', sessionStorage.tokenParams) }|${ mGetUrlParam('partition', sessionStorage.tokenParams) }|${ mGetUrlParam('roleid', sessionStorage.tokenParams) }|${ pageid }|${ sourceid }|${ action }|${ targetid }|${ targettype }|${ tag }|${ title }|${ from }|${ Date.now() }|${ mGetUrlParam('adtag', sessionStorage.tokenParams) }|${ staytime }|${ path }|${ recid }|${ channelid }|${ top }`
//         })
//     })
// }
